import {MSG} from '../proto/proto';

export namespace $WS {
    //
    export const MESSAGE_SPLIT: string = '.';

    //心跳检测间隔
    export const HEART_TICK_TIME: number = 6.1e3;
    //心跳包发送间隔
    export const HEART_SEND_TIME: number = 2e3;

    //
    export enum ProtoHead {
        SYNC = 0,        //游戏内同步消息
        HALL = 1,
        GAME = 2,
        PING = 3,
        PONG = 4,
        FPS_SYNC = 5,
    }

    export function getHallGameProtoHeadObject(head: number, headType: $WS.ProtoHead, gameId?: number) {
        switch (headType) {
            case $WS.ProtoHead.HALL: {
                return {
                    msgType: $WS.ProtoHead.HALL,
                    hallHead: head,
                };
            }
            case $WS.ProtoHead.GAME: {
                return {
                    msgType: $WS.ProtoHead.GAME,
                    gameId: gameId,
                    gameHead: head,
                };
            }
            case $WS.ProtoHead.SYNC: {
                return {
                    msgType: $WS.ProtoHead.SYNC,
                };
            }
            case $WS.ProtoHead.FPS_SYNC: {
                return {
                    msgType: $WS.ProtoHead.FPS_SYNC,
                }
            }
            default: {
                break;
            }
        }
    }

    //协议头
    export interface WebSocketProtoHeadBody {
        head: number;
        body?: string | object;

        //序列化
        getPackageBody?: (...args) => Uint8Array;
    }

    export function getMessageHead(message: string) {
        let i = message.indexOf('.');
        if (i == -1) {
            console.error('#231737 异常消息', message);
            return null;
        }
        const head = message.substring(0, i);
        return head;
    }

    //打包
    export function packageMessage(wsMessage: WebSocketProtoHeadBody): string {
        const {head, body} = wsMessage;
        //json
        // if ($WS.JSON_PROTO) {
        //     // if (typeof body == 'object') {
        //     //     return `${head}${$WS.MESSAGE_SPLIT}${JSON.stringify(body)}`;
        //     // } else {
        //     //     return `${head}${$WS.MESSAGE_SPLIT}${body || ''}`;
        //     // }
        // } else {
        if (wsMessage.getPackageBody) {
            const protoList = wsMessage.getPackageBody();
            return `${head}${$WS.MESSAGE_SPLIT}${JSON.stringify(protoList)}`;
        } else if (body && typeof body == 'string') {
            return `${head}${$WS.MESSAGE_SPLIT}${wsMessage.body}`;
        } else {
            return `${head}${$WS.MESSAGE_SPLIT}`;
        }
        // }
    }

    //解包
    export function unPackageMessage(message: Uint8Array): $WS.ProtoHead {
        const fMsg = MSG.Msg.decode(message);
        if (fMsg && fMsg['msgType'] != null) {
            return fMsg['msgType'];
        }
        return null;
    }

    export enum ERROR_CODE {
        //心跳超时
        HeartTimeOut = 10001,
    }

    //房间状态
    export enum RoomState {
        NULL,
        FREE,
        PLAYING,
        OVER,
    }
}

